import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-header"
};
import { CloseBold, CopyDocument } from '@element-plus/icons-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    headerName: {},
    shareLink: {
      default: ''
    },
    guideLink: {
      default: ''
    }
  },
  emits: ["close"],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const closeTab = () => {
      emits('close');
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h1", null, _toDisplayString(_ctx.headerName), 1), _ctx.shareLink !== '' ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        class: "box-item",
        effect: "light",
        content: "Copy share link",
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          class: "share-link",
          icon: _unref(CopyDocument),
          size: "small",
          circle: ""
        }, null, 8, ["icon"])]),
        _: 1
      })) : _createCommentVNode("", true), _ctx.guideLink !== '' ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 1,
        class: "box-item",
        effect: "light",
        content: "MCT Guide",
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_link, {
          class: "guide-link",
          href: _ctx.guideLink,
          target: "_blank",
          underline: false
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "guide-icon",
            type: "primary",
            size: "small",
            plain: "",
            circle: ""
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" ? ")])),
            _: 1
          })]),
          _: 1
        }, 8, ["href"])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        class: "close-btn",
        onClick: closeTab,
        link: "",
        icon: _unref(CloseBold)
      }, null, 8, ["icon"])]);
    };
  }
});